// useScanner.ts
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  fetchSwingScannerResults,
  fetchScreenerScannerResults,
  scanSwingStocks as scanSwingStocksService,
  syncStocks,
  // scanScreenerStocks,
} from "../services/scannerService";
import api from "services/api";

export default function useScanner() {
  const [swingStocksResults, setSwingStocksResults] = useState<any[]>([]);
  const [scanning, setScanning] = useState<boolean>(false);
  const [syncing, setSyncing] = useState<boolean>(false);

  // Fetch scanner data and subscribe
  useEffect(() => {
    const loadData = async () => {
      const nifty = await fetchSwingScannerResults();
      setSwingStocksResults(nifty);
    };

    loadData();
  }, []);

  const syncAllStocks = async () => {
    setSyncing(true);
    try {
      await syncStocks();
      toast.info("✅ Stock sync started in background...");

      // Poll for status
      const pollInterval = setInterval(async () => {
        try {
          const res = await api.get("/scanner/scan/status");
          if (!res.data.syncing) {
            clearInterval(pollInterval);
            setSyncing(false);
            toast.success("✅ Stock Sync Completed!");
          }
        } catch (err) {
          console.error("Sync polling error", err);
          clearInterval(pollInterval);
          setSyncing(false);
        }
      }, 5000);

    } catch (err) {
      console.error("Failed to start sync", err);
      setSyncing(false);
      toast.error("❌ Failed to start stock sync");
    }
  };

  const scanSwingStocks = async () => {
    console.log("scan swing stocks");
    setScanning(true);
    try {
      // Trigger scan (returns immediately now)
      await scanSwingStocksService();
      toast.info("🚀 Scan started in background...");
      
      // Poll for status
      const pollInterval = setInterval(async () => {
        try {
          const res = await api.get("/scanner/scan/status");
          // const data = await res.json();
          
          if (!res.data.scanning) {
            clearInterval(pollInterval);
            setScanning(false);
            toast.success("✅ Scan Completed! Refreshing results...");
            const results = await fetchSwingScannerResults();
            setSwingStocksResults(results);
          }
        } catch (err) {
          console.error("Polling error", err);
          clearInterval(pollInterval);
          setScanning(false);
        }
      }, 5000); // Check every 5 seconds

    } catch (err) {
      console.error("Failed to start scan", err);
      setScanning(false);
      toast.error("❌ Failed to start scan");
    }
  };
  // const scanScreener = async () => {
  //   setScanning(true);
  //   await scanScreenerStocks().then((result) => {
  //     setScanning(false);
  //     setScreenerScannerResults(result);
  //   });
  // };

  return {
    swingStocksResults,
    scanSwingStocks,
    syncAllStocks,
    scanning,
    syncing,
  };
}

// import { useEffect, useState } from "react";
// import { getScannerResults } from "../services/scannerService";
// import { useWebSocket } from "./useWebSocket";

// export function useScanner() {
//   const [scannerResults, setScannerResults] = useState<any[]>([]);
//   const { registerHandler } = useWebSocket();

//   const fetchScannerResults = async () => {
//     try {
//       const results = await getScannerResults();
//       setScannerResults(results);
//     } catch (error) {
//       console.error("Error fetching scanner results:", error);
//     }
//   };

//   useEffect(() => {
//     fetchScannerResults();
//     registerHandler("SCANNER_UPDATED", () => {
//       fetchScannerResults();
//     });
//   }, []);

//   return { scannerResults, refreshScanner: fetchScannerResults };
// }
